import EmailIconWrapper from '../Base/EmailIconWrapper';
import EmailInput from '../Base/EmailInput';
import InputWrapper from '../Base/InputWrapper';
import SubmitButton from '../Base/SubmitButton';
import type { TemplateProps } from '../types';

const Template1 = ({ signupStyles, isSubmitting, autoFocus, setEmail, onEmailChange }: TemplateProps) => {
  const {
    fontFamily,
    fontSize,
    buttonFontFamily,
    buttonBgColor,
    buttonTextColor,
    placeholderBgColor,
    placeholderTextColor,
    buttonText,
    placeholderText,
    borderEnabled,
    borderColor,
    emailIconEnabled,
  } = signupStyles;

  return (
    <InputWrapper
      style={{
        backgroundColor: placeholderBgColor,
        border: borderEnabled ? `2px solid ${borderColor}` : 'none',
      }}
      className="overflow-hidden p-1"
    >
      <EmailIconWrapper
        color={buttonBgColor || ''}
        style={{
          backgroundColor: placeholderBgColor,
        }}
        iconEnabled={emailIconEnabled}
      >
        <EmailInput
          fontFamily={fontFamily}
          fontSize={fontSize}
          autoFocus={autoFocus}
          setEmail={setEmail}
          onEmailChange={onEmailChange}
          placeholderText={placeholderText}
          textColor={placeholderTextColor}
        />
      </EmailIconWrapper>
      <SubmitButton
        isSubmitting={isSubmitting}
        fontFamily={buttonFontFamily}
        fontSize={fontSize}
        ctaText={buttonText}
        backgroundColor={buttonBgColor}
        textColor={buttonTextColor}
      />
    </InputWrapper>
  );
};

export default Template1;
